import { TimePicker } from "antd";
import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: #fff;
  padding: 24px;
  border-radius: 16px;
`;
export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const FilterContainer = styled.div`
  padding: 10px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
`;
export const FilterItem = styled.div`
  flex-grow: 1;
  flex-basis: auto;
  max-width: 300px;
`;
export const Title = styled.h4`
  color: #28303f;
  font-size: 24px;
  font-weight: 600;
`;

export const Label = styled.span`
  color: #a8a8a8;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 4px;
`;
